// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5695":"740bdaa2","6600":"60fc5829"}[chunkId] + ".chunk.css";
};